import React from 'react';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

import { Form, Button } from 'react-bootstrap';

import * as turf from '@turf/turf';
import { Formik } from 'formik';
import * as yup from 'yup';

import { Farm, Field, Grower, Variety } from '../../../types/types';
import { CREATE_FIELD, GET_FARMS, GET_GROWERS2, UPDATE_FIELD } from '../../../../../queries';
import { GetFarms, GetGrowers, landscan_fields_insert_input } from '../../../../../__generated__/types';
import { useMutation, useQuery } from 'react-apollo';
import { CreateGrower } from './CreateGrower';
import { CreateFarm } from './CreateFarm';
import { useRouteMatch } from 'react-router-dom';
import { useStore } from '../../../providers/AppProvider';
import { useUnitConversion, formatUnitAbbreviation} from '../../../utils/unitConversion';
import { dcRound } from '../../../utils/misc';
import _ from 'lodash';

const schema = yup.object().shape({
    name: yup.string().required().max(255),
    year_planted: yup.number(),
    // CHANGED: validate 'area' (preferred units) instead of 'acres'
    area: yup.number().positive('a valid block size is required').nullable(),
    acres: yup.number().positive().nullable(),  // legacy mirror; no longer required
    grower_id: yup.number(),
    farm_id: yup.number(),
    crop_id: yup.number(),//.required('crop is required'),
    variety_id: yup.number(),
    plant_spacing: yup.number().positive('a valid plant spacing is required'),
    row_spacing: yup.number().positive('a valid row spacing is required'),
    url: yup.string().url().max(512)
});

type FieldFormValues = {
    grower_id: string,
    farm_id: string,
    name: string,
    crop_id: string,
    variety_id: string,
    year_planted: string,
    acres: string,
    area: string, // NEW: preferred area units (no conversion)
    plant_spacing: string,
    row_spacing: string,
    url: string
};

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

const EditFieldForm = (props: any) => {
    const match = useRouteMatch(`${FIELD_APP_URL}/:vp/fields`);
    const history = useHistory();
    console.log("D050724 props", props);
    const { state: { crops, varieties }, orgId } = useStore();

    const { data: growerData, refetch: refetchFarms } = useQuery<GetGrowers>(GET_GROWERS2);
    const { data: farmData, refetch: refetchGrowers } = useQuery<GetFarms>(GET_FARMS);

    const { convertToPreferredUnitValue, convertToPreferredUnitString, unitsConvert } = useUnitConversion();
    const { localePreferences } = useStore();

    // preferred area unit abbr (for label and submission)
    const preferredAreaMid = _.get(localePreferences, 'measureUnits.area.mid');
    const preferredAreaAbbr: string =
        typeof preferredAreaMid === 'string' ? preferredAreaMid : preferredAreaMid?.abbr || 'ac';

    // [LEN] preferred length unit abbr (for spacing label/input + submission)
    const preferredLenMid = _.get(localePreferences, 'measureUnits.length.mid');
    const preferredLenAbbr: string =
        typeof preferredLenMid === 'string' ? preferredLenMid : preferredLenMid?.abbr || 'ft';

    useEffect(() => {
        refetchFarms();
        refetchGrowers();
    }, []);

    const [createField] = useMutation(CREATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match?.url}`);
        }
    });

    const [updateField] = useMutation(UPDATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match?.url}`);
        }
    });

    const [editField, setEditField] = useState<Field | null>(props.fieldToEdit);
    const [currentCropVarieties, setCurrentCropVarieties] = useState<Variety[]>([]);
    const [currrentGrowerFarms, setCurrentGrowerFarms] = useState<Farm[]>([]);
    const [growers, setGrowers] = useState<Grower[]>([]);
    const [currentGrowerId, setCurrentGrowerId] = useState<number | null>(null);
    const [farms, setFarms] = useState<Farm[]>([]);

    const [feature, setFeature] = useState<any>(null);
    const [multiFeatures, setMultiFeatures] = useState<any>(null);
    const [hasFeature, setHasFeature] = useState<boolean>(false);
    const [featureArea, setfeatureArea] = useState<number | null>(null);
    const [defaultValues, setDefaultValues] = useState<FieldFormValues>({
        grower_id: "",
        farm_id: "",
        name: "",
        crop_id: "",
        variety_id: "",
        year_planted: "",
        acres: "",
        area: "", // NEW: preferred area units (no conversion)
        plant_spacing: "",
        row_spacing: "",
        url: ""
    });

    const [showCreateGrower, setShowCreateGrower] = useState<boolean>(false);
    const [showCreateFarm, setShowCreateFarm] = useState<boolean>(false);


    useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
                id: g.grower_id,
                name: g.name,
                description: g.description
            } as Grower
        }) : []);
    }, [growerData]);
    
    useEffect(() => {
        console.log("D050724 editField", editField);
    }, [editField]);


    useEffect(() => {
        console.log("D050724 farmData", farmData);
        setFarms(farmData ? farmData.landscan_farms.map(f => { 
            return {
                id: f.farm_id,
                grower_id: f.grower_id,
                name: f.name,
                description: f.description
            } as Farm
        }) : []);
    }, [farmData]);


    useEffect(() => {
        // force to update the list of the current grower
        // when the data updates.
        if(currentGrowerId) {
            setGrowersFarms(currentGrowerId);
        }
    }, [farms]);

    useEffect(() => {
        console.log("D050724 props.feature", props.feature);
        console.log("D050724 props.featureFragments", props.featureFragments);
        setFeature(props.feature && props.feature.length ? props.feature[0] : null);
        setMultiFeatures(props.featureFragments);
        //setHasFeature(props.feature && props.feature.length);
        setHasFeature(props.featureFragments && props.featureFragments.features.length);
    }, [props.feature, props.featureFragments]);

    useEffect(() => {
        //setfeatureArea(feature ? calculateAcres(feature) : null);
    }, [feature]);

    useEffect(() => {
        console.log('D050724 multiFeatures', multiFeatures);
        let acres = 0;
        multiFeatures && multiFeatures.features.forEach((f: any) => {
            console.log('D050724 f', f);
            let subacres = calculateAcres(f);
            console.log('D050724 subacres', subacres);
            acres += subacres;
            console.log('D050724 acres', acres);
        });
        setfeatureArea(acres);
    }, [multiFeatures]);


    const setCropVarieties = (cropId: number) => {
        setCurrentCropVarieties(cropId > 0 ? varieties.filter((v: Variety) => v.crop_id === cropId) : []);
    }


    const setGrowersFarms = (growerId: number) => {
        setCurrentGrowerFarms(growerId > 0 ? farms.filter((f: Farm) => f.grower_id === growerId) : [])
    }


    const years = (startYear: number) => {
        const currentYear = new Date().getFullYear();
        const years: number[] = [];
        startYear = startYear || 1980;
        while (startYear <= currentYear) {
            years.push(startYear++);
        }
        return years.reverse();
    }


    const calculateAcres = (geojsonFeature: any) => {
        const polygon = turf.polygon(geojsonFeature.geometry.coordinates);
        return turf.area(polygon) * 0.00024711
    }

    // ---------- NEW helpers for seeding/formatting Block Size ----------
    const toNum = (v: any) => {
        if (v === '' || v == null) return NaN;
        const n = Number(String(v).replace(/,/g, ''));
        return Number.isFinite(n) ? n : NaN;
    };

    // derive a preferred-units numeric from DB fields: area(+unit) or acres
    const getPreferredAreaFromRecord = (rec: any): { valueStr: string, infoText: string } => {
        let displayValue = '';      // numeric string in preferred units (for the input)
        let infoText = 'n/a';       // human string with unit name (for helper text)

        if (rec) {
            const dbArea = toNum(rec.area);
            const dbUnitAbbr = rec.area_unit_abbrev as string | undefined;

            if (Number.isFinite(dbArea) && dbUnitAbbr) {
                // convert area (db units) -> preferred units
                const localVal = convertToPreferredUnitValue(dbArea, dbUnitAbbr, 'area', 'mid');
                console.log("B082125 dbAreaUnitAbbrev", dbUnitAbbr);
                console.log("B082125 dbArea", dbArea);
                console.log("B082125 localVal", localVal);
                if (localVal != null) {
                    displayValue = String(dcRound(localVal as number, undefined, undefined, true));
                    infoText = convertToPreferredUnitString(dbArea, dbUnitAbbr, 'area', 'mid', 'name');
                    let displayValueConverted = convertToPreferredUnitValue(dbArea, dbUnitAbbr, 'area', 'mid');
                    console.log("B082125 displayValue", displayValue);
                    console.log("B082125 infoText", infoText);
                    console.log("B082125 displayValueConverted", displayValueConverted);
                    return { valueStr: displayValue, infoText };
                }
            }

            const legacyAc = toNum(rec.acres);
            if (Number.isFinite(legacyAc)) {
                const localVal = convertToPreferredUnitValue(legacyAc, 'ac', 'area', 'mid');
                if (localVal != null) {
                    displayValue = String(dcRound(localVal as number, undefined, undefined, true));
                    infoText = convertToPreferredUnitString(legacyAc, 'ac', 'area', 'mid', 'name');
                    return { valueStr: displayValue, infoText };
                }
            }
        }

        return { valueStr: '', infoText };
    };
    // -------------------------------------------------------------------

    const onSubmit = async (data: FieldFormValues) => {
        console.log('D050724 data', data);

        // convert to a multi-polygon since the edit only returns polygons
        let geometry:any = null;
        if (feature && feature.geometry){
            geometry = {...feature.geometry};
            geometry.coordinates = [geometry.coordinates];      
            geometry.type = "MultiPolygon";
            geometry.crs = {
                "type": "name",
                "properties": {
                "name": "urn:ogc:def:crs:EPSG::4326"
                }
            };
        }
        let _geometry = {...multiFeatures.geometry};
        _geometry.coordinates = multiFeatures.features.map((f: any) => {
                console.log("D050724 f", f);
                return [f.geometry.coordinates[0]];
            })
        _geometry.type = "MultiPolygon";
        _geometry.crs = {
            "type": "name",
            "properties": {
              "name": "urn:ogc:def:crs:EPSG::4326"
            }
        };

        // ---------- CHANGED: Only persist area (preferred units) + area_unit_abbrev ----------
        const preferredAreaMidLocal = _.get(localePreferences, 'measureUnits.area.mid');
        const preferredAreaAbbrLocal: string =
            typeof preferredAreaMidLocal === 'string' ? preferredAreaMidLocal : preferredAreaMidLocal?.abbr || 'ac';

        const areaVal = toNum(data.area); // already in preferred units per the input

        // If area input is blank, fall back to polygon-computed size
        let finalAreaVal: number | undefined = Number.isFinite(areaVal) ? areaVal : undefined;
        if (finalAreaVal === undefined && Number.isFinite(featureArea) && (featureArea as number) > 0) {
            const polygonInPreferred = preferredAreaAbbrLocal === 'ac'
                ? featureArea as number
                : Number(unitsConvert(featureArea as number, 'ac', preferredAreaAbbrLocal));
            if (Number.isFinite(polygonInPreferred)) {
                finalAreaVal = Math.round(polygonInPreferred * 1000) / 1000;
            }
        }
        // -----------------------------------------------------------------------------

        // [LEN] Pull spacing values (already shown/entered in preferred units)
        const plantSpacingVal = data.plant_spacing !== "" ? parseFloat(data.plant_spacing) : null;
        const rowSpacingVal   = data.row_spacing   !== "" ? parseFloat(data.row_spacing)   : null;

        const field: landscan_fields_insert_input = {
            org_id: orgId,
            field_id: editField ? editField.id : undefined,
            name: data.name,
            grower_id: data.grower_id !== "" ? parseInt(data.grower_id) : null,
            farm_id: data.farm_id !== "" ? parseInt(data.farm_id) : null,
            crop_id: data.crop_id !== "" ? parseInt(data.crop_id) : null,
            variety_id: data.variety_id !== "" ? parseInt(data.variety_id) : null,

            // CHANGED: do not update acres here; only area + area_unit_abbrev
            area: Number.isFinite(finalAreaVal) ? finalAreaVal : undefined,
            area_unit_abbrev: preferredAreaAbbrLocal,

            // [LEN] Save spacing values in preferred units + unit abbr
            plant_spacing: plantSpacingVal,
            plant_spacing_unit_abbrev: plantSpacingVal != null ? preferredLenAbbr : undefined,
            row_spacing: rowSpacingVal,
            row_spacing_unit_abbrev: rowSpacingVal != null ? preferredLenAbbr : undefined,

            year_planted: data.year_planted !== "" ? parseInt(data.year_planted) : null,
            url: data.url,
            geom: JSON.stringify(_geometry)
        };
        console.log('A082125 multiFeatures', multiFeatures);
        console.log('A082125 _geometry', _geometry);
        console.log('A082125 geometry', geometry);
        console.log('A082125 field', field);
        if (editField) {
            await updateField({ variables: {id: editField.id, data: field} } );
        } else {
            await createField({ variables: {data: field} } );
        }
    }


    useEffect(() => {
        setEditField(props.fieldToEdit);

        if (props.fieldToEdit) {
            // crop is required
            setCropVarieties(props.fieldToEdit['crop_id']);

            // could be null, not required, null ok
            setCurrentGrowerId(props.fieldToEdit['grower_id']);

            // only if not null
            if(props.fieldToEdit['grower_id']) {
                setGrowersFarms(props.fieldToEdit['grower_id']);
            }

            let resetValues: FieldFormValues = {} as FieldFormValues;
            const fields = ['name', 'grower_id', 'farm_id', 'crop_id', 'acres', 'plant_spacing', 'row_spacing', 'year_planted', 'variety_id', 'url'];
            fields.forEach(f => resetValues[f as keyof FieldFormValues] = props.fieldToEdit[f] ? props.fieldToEdit[f] as string : '');

            // ---------- NEW: seed 'area' input from (area+unit) or acres, in preferred units ----------
            const seeded = getPreferredAreaFromRecord(props.fieldToEdit);
            resetValues.area = seeded.valueStr;
            // -----------------------------------------------------------------------------------------

            // [LEN] Seed spacing inputs from DB (convert DB unit -> preferred unit)
            const dbPS = toNum((props.fieldToEdit as any).plant_spacing);
            const dbPSUnit: string | undefined = (props.fieldToEdit as any).plant_spacing_unit_abbrev;
            if (Number.isFinite(dbPS) && dbPSUnit) {
                try {
                    const psLocal = unitsConvert(dbPS, dbPSUnit, preferredLenAbbr);
                    if (Number.isFinite(psLocal)) {
                        resetValues.plant_spacing = String(dcRound(psLocal as number, undefined, undefined, true));
                    }
                } catch {}
            }
            const dbRS = toNum((props.fieldToEdit as any).row_spacing);
            const dbRSUnit: string | undefined = (props.fieldToEdit as any).row_spacing_unit_abbrev;
            if (Number.isFinite(dbRS) && dbRSUnit) {
                try {
                    const rsLocal = unitsConvert(dbRS, dbRSUnit, preferredLenAbbr);
                    if (Number.isFinite(rsLocal)) {
                        resetValues.row_spacing = String(dcRound(rsLocal as number, undefined, undefined, true));
                    }
                } catch {}
            }

            setDefaultValues(resetValues);
        }
    }, [props.fieldToEdit, unitsConvert, preferredLenAbbr]);

    const storedSizeText = (() => {
        if (!editField) return 'n/a';

        // Primary: new schema with area + unit
        const dbArea = toNum((editField as any).area);
        const dbUnit = (editField as any).area_unit_abbrev as string | undefined;
        if (Number.isFinite(dbArea) && dbUnit) {
            return `${dbArea} ${dbUnit}`;
        }

        // Legacy: fall back to acres if present
        const legacyAc = toNum((editField as any).acres);
        if (Number.isFinite(legacyAc)) {
            return `${legacyAc} ac`;
        }

        return 'n/a';
    })();

    // [LEN] Stored spacing texts (raw DB value + unit abbr)
    const storedPlantSpacingText = (() => {
        if (!editField) return 'n/a';
        const val = toNum((editField as any).plant_spacing);
        const unit = (editField as any).plant_spacing_unit_abbrev as string | undefined;
        if (Number.isFinite(val) && unit) return `${val} ${unit}`;
        return 'n/a';
    })();
    const storedRowSpacingText = (() => {
        if (!editField) return 'n/a';
        const val = toNum((editField as any).row_spacing);
        const unit = (editField as any).row_spacing_unit_abbrev as string | undefined;
        if (Number.isFinite(val) && unit) return `${val} ${unit}`;
        return 'n/a';
    })();


    return (
        <div className="d-flex flex-column h-100 pb-2">
            <CreateGrower isOpen={showCreateGrower} onClose={() => setShowCreateGrower(false)} />
            <CreateFarm isOpen={showCreateFarm} onClose={() => setShowCreateFarm(false)} />
            <div className="d-flex justify-content-between p-3">
                <h4>{editField ? 'Edit Block' : 'New Block'}</h4>
            </div>
            <div className="flex-grow-1 pt-0 pb-2 px-3 pt-2 overflow-auto" style={{flexBasis: 0}}>
                <Formik
                    enableReinitialize={true}
                    initialValues={defaultValues}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={async (values, { setSubmitting }) => {
                        // if we made it this far, the form validation passed.
                        // check for kinks in the polygon.
                        //const featureCol = turf.kinks(feature);
                        console.log('E050724 props.featureFragments', props.featureFragments);
                        multiFeatures.features.forEach((f: any) => {
                            console.log('E050724 f', f);
                            const featureCol = turf.kinks(f);
                            console.log('E050724 featureCol', featureCol);
                            if(featureCol.features.length > 0) {
                                alert('The block polygon is invalid. A polygon that overlaps itself is not allowed.');
                                return;
                            }
                        });
                      
                        setSubmitting(true);
                        await onSubmit(values);
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit} autoComplete="off" className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Block</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            size="sm"
                                            placeholder="Enter block name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label className="d-flex justify-content-between">
                                            Grower
                                        </Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="grower_id"
                                                size="sm"
                                                value={values.grower_id}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.grower_id}
                                                onChange={e => {
                                                    handleChange(e);
                                                    setFieldValue('farm_id', ""); // reset farm
                                                    setCurrentGrowerId(e.currentTarget.value ? parseInt(e.currentTarget.value) : null);
                                                    setGrowersFarms(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                                }}
                                            >
                                                <option value="" label="Select a grower" disabled />
                                                {growers.map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                            <Button size="sm" className="ml-2" title="Create" onClick={() => setShowCreateGrower(true)}>
                                                +
                                            </Button>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.grower_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label className="d-flex justify-content-between">
                                            Farm
                                        </Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="farm_id"
                                                size="sm"
                                                value={values.farm_id}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.farm_id}
                                            >
                                                <option value="" label="Select a farm" disabled />
                                                {currrentGrowerFarms.map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                            <Button size="sm" className="ml-2" title="Create" onClick={() => setShowCreateFarm(true)}>
                                                +
                                            </Button>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.farm_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Year Planted</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="year_planted"
                                            size="sm"
                                            value={values.year_planted}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.year_planted}
                                        >
                                            <option key={-1} value="" disabled>Select a year</option>
                                            {years(1990).map(year => {
                                                return <option key={year} value={year}>{year}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.year_planted}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Crop</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="crop_id"
                                            size="sm"
                                            value={values.crop_id}
                                            onChange={e => {
                                                handleChange(e);
                                                setFieldValue('variety_id', "");
                                                setCropVarieties(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                            }}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.crop_id}
                                        >
                                            <option key={-1} value="" disabled>{'Select a crop'}</option>
                                            {crops.map(c => {
                                                return <option key={c.id} value={c.id}>{c.name}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.crop_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Variety</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="variety_id"
                                            size="sm"
                                            value={values.variety_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.variety_id}
                                        >
                                            <option key={-1} value="" disabled>{'Select a variety'}</option>
                                            {currentCropVarieties.map(v => {
                                                return <option key={v.id} value={v.id}>{v.name}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.variety_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {/* CHANGED: Block Size now bound to `area` (preferred units) */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            Block Size
                                            <span className="text-muted"> ({formatUnitAbbreviation(preferredAreaAbbr)})</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="area"
                                            size="sm"
                                            placeholder="Enter block size"
                                            value={values.area}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.area}
                                        />
                                        {/* Display stored record’s size translated to preferred (name) units */}
                                        <Form.Text className="bg-info form-text px-2 text-white">
                                            Stored size: {storedSizeText}
                                        </Form.Text>
                                        {/* Keep calculated geometry size for reference (converted to preferred, name) */}
                                        <Form.Text className="bg-info form-text px-2 text-white">
                                            {featureArea != null
                                                ? `Polygon size: ${convertToPreferredUnitString(featureArea, 'ac', 'area', 'mid', 'abbr')}`
                                                : 'Polygon size: n/a'}
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.area as any}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {/* [LEN] Plant Spacing in preferred units + stored value */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            Plant Spacing 
                                            <span className="text-muted"> ({formatUnitAbbreviation(preferredLenAbbr)})</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="plant_spacing"
                                            size="sm"
                                            placeholder={`Enter plant spacing in ${formatUnitAbbreviation(preferredLenAbbr)}`}
                                            value={values.plant_spacing}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.plant_spacing}
                                        />
                                        <Form.Text className="bg-info form-text px-2 text-white">
                                            Stored value: {storedPlantSpacingText}
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.plant_spacing}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {/* [LEN] Row Spacing in preferred units + stored value */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            Row Spacing 
                                            <span className="text-muted"> ({formatUnitAbbreviation(preferredLenAbbr)})</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="row_spacing"
                                            size="sm"
                                            placeholder={`Enter row spacing in ${formatUnitAbbreviation(preferredLenAbbr)}`}
                                            value={values.row_spacing}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.row_spacing}
                                        />
                                        <Form.Text className="bg-info form-text px-2 text-white">
                                            Stored value: {storedRowSpacingText}
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.row_spacing}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Dashboard URL</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="url"
                                            size="sm"
                                            placeholder="Enter dashboard url"
                                            value={values.url}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.url}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.url}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2">
                                            <Button type="submit" variant="primary" size="sm" disabled={isSubmitting || !hasFeature}>
                                                {editField ? 'Update' : 'Create'}
                                            </Button>
                                            <Button variant="secondary" size="sm" className="mx-2" onClick={() => {
                                                history.push(`${match?.url}`);
                                            }}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
}

export default EditFieldForm;
